<div class="boxWhite">
  <h4>CREAR JORNADA</h4>

  <button class="btn btnClose" (click)="close()">
    <img src="assets/img/icoClose.svg" alt="">
  </button>

  <div class="contModal" [formGroup]="formCrear">
    <div class="mb-4">
      <!--<input type="search" class="form-control" placeholder="BUSCAR CONDUCTOR...">-->
      <ng-select formControlName="conductor" placeholder="BUSCAR CONDUCTOR..." [multiple]="false" [items]="listadoConductores" bindLabel="nombres"
                 [searchFn]="buscarConductorPorIDnombresCompleto">
        <!--<ng-option *ngFor="let recorrido of filterServicios" [value]="recorrido.uuid">
          {{recorrido.servicioHistoricoVigente?.nombre}}</ng-option>-->
        <ng-template ng-label-tmp let-item="item">
          <span >{{ item.visibleId + ' - ' + item.nombres + ' ' + item.apellidoPaterno }}</span>
        </ng-template>
        <ng-template ng-option-tmp let-item="item" let-search="searchTerm" let-index="index">
          <span >{{ item.visibleId + ' - ' + item.nombres + ' ' + item.apellidoPaterno }}</span>
        </ng-template>
      </ng-select>
    </div>
    <div class="mb-4">
      <!--<select class="form-select">
        <option selected disabled>SELECCIONE TERMINAL</option>
      </select>-->
      <ng-select placeholder="SELECCIONE TERMINAL" formControlName="sucursal" [multiple]="false" bindLabel="nombre" [items]="listadoSucursalesDisponibles">
      </ng-select>
    </div>

    <div class="row">
      <div class="col-sm-6">
        <div class="mb-4">
          <h6 class="clBlack">Fecha de inicio</h6>
          <input type="text" class="form-control" placeholder="FECHA INICIO" bsDatepicker formControlName="fechaInicio"
                 [bsConfig]="{dateInputFormat: 'DD-MM-YYYY'}">
        </div>
      </div>
      <div class="col-sm-6">
        <div class="mb-4">
          <h6 class="clBlack">Hora de inicio</h6>
          <input type="time" class="form-control" placeholder="HORA INICIO" formControlName="horaInicio">
        </div>
      </div>

      <div class="col-sm-6">
        <div class="mb-4">
          <h6 class="clBlack">Fecha de término</h6>
          <input type="text" class="form-control" placeholder="FECHA TÉMINO" bsDatepicker formControlName="fechaTermino"
                 [bsConfig]="{dateInputFormat: 'DD-MM-YYYY'}">
        </div>
      </div>
      <div class="col-sm-6">
        <div class="mb-4">
          <h6 class="clBlack">Hora de término</h6>
          <input type="time" class="form-control" placeholder="HORA TÉRMINO" formControlName="horaTermino">
        </div>
      </div>
    </div>
  </div>


  <div class="footModal">
    <button *ngIf="tienePermisoCrearJornada()" class="btn btnOrange w-100" (click)="postCrearJornada()" [disabled]="creando">{{creando ? 'CREANDO...' : 'CREAR JORNADA'}}</button>
  </div>


</div>
